import React,{useState,useEffect,useRef} from "react";

  import { useRouteMatch,Switch, Route ,Link} from "react-router-dom";
import { useHistory,} from "react-router-dom";

import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import {X,Plus ,Star,BookmarkPlus,Phone,Check,ChevronRight,Video,MonitorPlay,BookOpenCheck,
  TabletSmartphone,NotebookPen,BookDown,NotepadText,BookA,GalleryHorizontal,BadgePlus,Aperture,Blocks,CalendarCog,
  List,
  Grid2x2X,
  Grid2X2,
  Grid2x2,
  ListTodo,
  ChevronLeft} from 'lucide-react';

const ContentMenuCardTwo =({loadingText,type,activeCard,icon,title ,onClickPopup})=>{

    const [clickStatus, setClickStatus] =useState(false)

 const Icon=   icon===0?<BookDown size={23}  color="#90CAF9" />:icon===1?<NotepadText size={23}  color="#90CAF9" 
        />:icon===2?<BookA size={23}  color="#90CAF9"  
        />:icon===3?<GalleryHorizontal size={23}   color="#90CAF9"  
        />:icon===4?<MonitorPlay size={23} color="#90CAF9" 
        />:icon===5?
       <Aperture size={23}   color="#90CAF9" />
       :icon===6?<Blocks size={23}  color="#90CAF9" />:icon===7?<CalendarCog size={23}  color="#90CAF9" />
       :icon===8?<X size={23}  color="#90CAF9" />:icon===9?<Plus size={23}  color="#90CAF9" />
:icon===10?<Check size={23}  color="#90CAF9" />:icon===11?<ListTodo size={23}  color="#90CAF9" />
:icon===12?<ChevronLeft size={23}  color="#90CAF9" />:"";
     
 const iconWhite=   icon===0?<BookDown size={23}  color="#fff" />:icon===1?<NotepadText size={23}  color="#fff" 
 />:icon===2?<BookA size={23}  color="#fff"  
 />:icon===3?<GalleryHorizontal size={23}   color="#fff"  
 />:icon===4?<MonitorPlay size={23} color="#fff" 
 />:icon===5?
<Aperture size={23}   color="#fff" />
:icon===6?<Blocks size={23}  color="#fff" />:icon===7?<CalendarCog size={23}  color="#fff" />
:icon===8?<X size={23}  color="#fff" />:icon===9?<Plus size={23}  color="#fff" />
:icon===10?<Check size={23}  color="#fff" />:icon===11?<ListTodo size={23}  color="#fff" />
:icon===12?<ChevronLeft size={23}  color="#fff" />:"";

     const dispatch = useDispatch();
     
      
    const handleMouseEnter = (CursorTextBg,CursorTextColor,CursorText) =>
        {
          
          dispatch({type: "CURSOR",payload:true  });
      
          dispatch({type: "CURSORTEXT",payload:CursorText})
          dispatch({type: "CURSORTEXTBG",payload:CursorTextBg})
          dispatch({type: "CURSORTEXTCOLOR",payload:CursorTextColor})
        }
         
        const handleMouseLeave = () => {
          
          dispatch({type: "CURSOR",payload:false})
      
          dispatch({type: "CURSORTEXT",payload:""})
      
          dispatch({type: "CURSORTEXTBG",payload:""})
          dispatch({type: "CURSORTEXTCOLOR",payload:""})
        
      
      }
      const cardBg =activeCard?"rgba(139, 224, 237,0.3)":"rgba(255,114,94,0.3)";
      const styleCard={marginBottom:"20px",height:"50px",cursor:"pointer",background:cardBg,border:"0px solid #fff",padding:"5px"}
      const cardBgIcon =activeCard?"rgb(139, 224, 237)":"rgba(255,114,94,0.7)";
      const styleCardIconIcon={background:cardBgIcon,width:"40px",height:"40px",borderRadius:"15%",
        alignContent:"center",textAlign:"center",padding:"5px",}
      return (<>
        <div   onMouseEnter={
                ()=>handleMouseEnter("","","")}
onMouseLeave={handleMouseLeave}  onClick={()=>{setClickStatus(true);setTimeout(()=>{onClickPopup();},1)}} align="left" className="itemRightOuterAppMenuTwo"
 style={styleCard} > 
<div style={styleCardIconIcon}>{activeCard?iconWhite:iconWhite}</div>
 <div  style={{fontSize:"22px",padding:"10px",textAlign:"center",fontWeight:"bold"}}>{clickStatus?loadingText:title}</div>
   </div></>)
}
export default ContentMenuCardTwo;

